module.exports = __webpack_public_path__ + "static/media/RCCL.c315aa55.svg";